module.exports = __webpack_public_path__ + "img/hideshow-off.4d9bb27c.svg";